import {
  SET_MODAL_TYPE,
  SET_PROGRESS_VALUE,
  TOGGLE_CUSTOM_MODAL,
} from '../../actionConstants';

import { CONFIRM, INFO, PROGRESS, RENDER_PROPS } from './modalTypes';

export const setIsCustomModalShown = (dispatch, isShown) =>
  dispatch({
    type: TOGGLE_CUSTOM_MODAL,
    isCustomModalShown: isShown,
  });

export const showInfoModal = (dispatch, info, confirmText) => {
  const modalProps = {
    bodyText: info,
    onConfirm: () => {},
    confirmText,
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: INFO,
    modalProps,
  });
};

export const showConfirmModal = (dispatch, modalProps) =>
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });

export const showRenderPropsModal = (dispatch, modalProps) =>
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: RENDER_PROPS,
    modalProps,
  });

export const setProgressValue = (dispatch, progressValue, id) =>
  dispatch({
    type: SET_PROGRESS_VALUE,
    modalType: PROGRESS,
    progressValue,
    id,
  });

export const onModalClose = (dispatch) =>
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: null,
  });
